import { createSlice } from '@reduxjs/toolkit';
import { OMSAPI } from '../../../../../API';
import { fetchIntegratedPlatform } from '../../integratedSlice';

export const zonosslice = createSlice({
    name: 'zonos',
    initialState: {
        progress: {
            data: {
                zonos_key: "",
            },
            message: "",
            loading: false,
            hasErrors: false
        },
        configure: {
            data: {},
            message: "",
            loading: false,
            hasErrors: false
        }
    },
    reducers: {
        fetchZonosDataDetails: (state) => {
            return {
                ...state,
                progress: {
                    loading: true
                }
            }
        },
        fetchZonosDataDetailsSuccess: (state, action) => {
            return {
                ...state,
                progress: {
                    message: action && action.payload && action.payload.data && action.payload.data.message,
                    data: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data,
                    loading: false,
                    hasErrors: false,
                }
            }
        },
        fetchZonosDataDetailsFailure: (state, action) => {
            return {
                ...state,
                progress: {
                    loading: false,
                    hasErrors: false,
                }
            }
        },
        postZonosConfigure: (state) => {
            return {
                ...state,
                configure: {
                    loading: true
                }
            }
        },
        postZonosConfigureSuccess: (state, action) => {
            return {
                ...state,
                configure: {
                    data: {},
                    message: action && action.payload && action.payload.data && action.payload.data.message,
                    loading: false,
                    hasErrors: false,
                }
            }
        },
        postZonosConfigureFailure: (state, action) => {
            return {
                ...state,
                configure: {
                    message: action && action.payload && action.payload.data && action.payload.data.message,
                    loading: false,
                    hasErrors: true,
                }
            }
        },
        resetConfigureStateDetails: (state, action) => {
            return {
                ...state,
                configure: {
                    data: {},
                    message: '',
                    loading: false,
                    hasErrors: false,
                }
            }
        },
        resetZonosStateDetails: (state, action) => {
            return {
                ...state,
                progress: {
                    data: {
                        zonos_key: "",
                    },
                    message: "",
                    loading: false,
                    hasErrors: false
                },
                configure: {
                    data: {},
                    message: '',
                    loading: false,
                    hasErrors: false,
                }
            }
        },
    }
})
export const { fetchZonosDataDetails, fetchZonosDataDetailsSuccess, fetchZonosDataDetailsFailure,
    postZonosConfigure, postZonosConfigureSuccess, postZonosConfigureFailure, resetConfigureStateDetails, resetZonosStateDetails } = zonosslice.actions;

export const configureStore = data => dispatch => {
    dispatch(postZonosConfigure());
    try {
        OMSAPI.post('/zonos/configure', data)
            .then(function (response) {
                dispatch(postZonosConfigureSuccess(response));
                dispatch(fetchIntegratedPlatform());
            }).catch(function (error) {
                dispatch(postZonosConfigureFailure(error.response));
            })
    }
    catch (error) {
        dispatch(postZonosConfigureFailure(error.response));
    }
}

export const fetchZonosData = data => dispatch => {
    dispatch(fetchZonosDataDetails())
    try {
        OMSAPI.post('/zonos/show', data)
            .then(function (response) {
                dispatch(fetchZonosDataDetailsSuccess(response));
            }).catch(function (error) {
                dispatch(fetchZonosDataDetailsFailure());
            })
    }
    catch (error) {
        dispatch(fetchZonosDataDetailsFailure())
    }
}

export const resetConfigureState = data => dispatch => {
    dispatch(resetConfigureStateDetails());
}

export const resetZonosState = data => dispatch => {
    dispatch(resetZonosStateDetails());
}
export default zonosslice.reducer;